import Axios from "@/utils/Axios";
import qs from "qs";

/**
 * 获取保存数据
 */
export function getSaveData(context) {
  let that = context;
  let param = {};
  param.method = "post";
  param.url = "/monitorBoard/monitorSafeData";
  param.data = qs.stringify({
    monitorSiteId: context.saveid,
  });
  return Axios.ajax(param).then((res) => {
    if (res.data) {
      if (context.lasttime === "") {
        context.lasttime = res.data.timestamp;
      } else {
        if (context.lasttime !== res.data.timestamp) {
          clearInterval(that.setsavedata);
          that.setsavedata = null;
          that.isload = false;
        }
      }
      if (res.data.electricMul) {
        context.electricMul = res.data.electricMul;
      }
      if (res.data.safeData.length !== 0) {
        if (context.isthree === '1') {
          context.singlesavedata = res.data.safeData.slice(0, 6);
          context.threesavedata = res.data.safeData.slice(1, 4);
          for (let i = 0; i < res.data.safeData.length; i++) {
            if (res.data.safeData[i].safeDataType === "漏电") {
              context.elelast.value = res.data.safeData[i].paramSafeDataList[0].paramValue;
              context.elelast.lev = res.data.safeData[i].paramSafeDataList[0].checkSafe;
            }
            if (res.data.safeData[i].safeDataType === "箱温") {
              context.boxtem.value = res.data.safeData[i].paramSafeDataList[0].paramValue;
              context.boxtem.lev = res.data.safeData[i].paramSafeDataList[0].checkSafe;
            }
            if (res.data.safeData[i].safeDataType === "风险指数") {
              context.dqhzparm.value = res.data.safeData[i].paramSafeDataList[0].paramValue;
              context.dqhzparm.lev = res.data.safeData[i].paramSafeDataList[0].checkSafe;
              if (res.data.safeData[i].paramSafeDataList.length > 1) {
                context.jylhparm.value = res.data.safeData[i].paramSafeDataList[1].paramValue;
                context.jylhparm.lev = res.data.safeData[i].paramSafeDataList[1].checkSafe;
              }
            }
          }
        } else if (context.isthree === '3') {
          context.elesavedata = res.data.safeData[0].paramSafeDataList[0];
        }
        else {
          for (let i = 0; i < res.data.safeData.length; i++) {
            if (res.data.safeData[i].safeDataType === "漏电") {
              context.elelast.value = res.data.safeData[i].paramSafeDataList[0].paramValue;
              context.elelast.lev = res.data.safeData[i].paramSafeDataList[0].checkSafe;
            }
            if (res.data.safeData[i].safeDataType === "箱温") {
              context.boxtem.value = res.data.safeData[i].paramSafeDataList[0].paramValue;
              context.boxtem.lev = res.data.safeData[i].paramSafeDataList[0].checkSafe;
            }
            if (res.data.safeData[i].safeDataType === "风险指数") {
              context.dqhzparm.value = res.data.safeData[i].paramSafeDataList[0].paramValue;
              context.dqhzparm.lev = res.data.safeData[i].paramSafeDataList[0].checkSafe;
              if (res.data.safeData[i].paramSafeDataList.length > 1) {
                context.jylhparm.value = res.data.safeData[i].paramSafeDataList[1].paramValue;
                context.jylhparm.lev = res.data.safeData[i].paramSafeDataList[1].checkSafe;
              }
            }
          }
          context.singlesavedata = res.data.safeData;
        }
      }
      else {
        context.isthree = null;
      }
    }

  });
}

/**
 * 获取电表倍率
 */
export function getdbbl(context) {
  let param = {};
  param.method = "post";
  param.url = "/monitorBoard/getElectricMul";
  param.data = {
    monitorSiteId: context.saveid,
  };
  return Axios.ajax(param).then((res) => {
    context.nowbl = res.data;
    context.nowbl2 = res.data;
  });
}

/**
 * 上传电表倍率
 */
export function uploadbl(context) {
  let that = context;
  let param = {};

  context.$confirm("建议专业电工人员确认后修改，倍率影响能耗统计，请确认修改", '提示', {
    confirmButtonText: "确认",
    cancelButtonText: "取消",
    type: 'warning'
  }).then(() => {
    param.method = "post";
    param.url = "/monitorBoard/setElectricMul";
    param.data = {
      monitorSiteId: that.saveid,
      electricMul: that.nowbl2,
    };
    return Axios.ajax(param).then((res) => {
      if (res.resultCode === '0') {
        that.$message({
          type: 'success',
          message: '修改成功!'
        });
        that.showbltc = false;
        that.getSaveData();
        that.getdbbl();
      } else {
        that.$message({
          type: 'error',
          message: res.msg
        });
      }
    });
  });
}

/**
 * 显示电表倍率
 */
export function showbl(context) {
  context.showbltc = true;
}